import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const References = (props) => {
	const references = props.data.references;

	if (!_.isArray(references) || _.isEmpty(references)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(references, ({ re_reference_name: referenceName }) => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{referenceName}
				</li>
			))}
		</ul>
	);
};

References.propTypes = {
	data: PropTypes.object.isRequired,
};

export default References;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/references.js